<div class="auth-wrapper">
  <div class="auth-content subscribe">
    <div class="card">
      <div class="row no-gutters">
        <div class="col-md-4 col-lg-6 d-none d-md-flex d-lg-flex theme-bg align-items-center justify-content-center">
          <img src="assets/images/user/lock.png" alt="lock images" class="img-fluid" />
        </div>
        <div class="col-md-8 col-lg-6">
          <div class="card-body text-center">
            <div class="row justify-content-center">
              <div class="col-sm-10">
                <form [formGroup]="formGroup">
                  <h3 class="mb-4 mt-5">Inicio de sesión</h3>
                  <div class="input-group mb-3 mt-2">
                    <input type="text" class="form-control" formControlName="userName" placeholder="Usuario" [ngClass]="{
                          'is-invalid': isInvalidUserName || (userField.hasError('required') || userField.hasError('customBlankSpacesValidator')) && (userField.dirty || userField.touched)
                        }" (input)="onUserNameInput()"/>
                  </div>
                  <div class="input-group mb-5">
                    <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password"
                      placeholder="Contraseña" formControlName="password" [ngClass]="{
                          'is-invalid': isInvalidPassword || (passwordField.hasError('required')) && (passwordField.dirty || passwordField.touched)
                        }" (input)="onPasswordInput()"/>
                    <span class="input-group-text" (click)="togglePasswordVisibility()">
                      <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                    </span>
                  </div>
                  <button class="btn btn-primary mb-4" [disabled]="disableButton"
                    (click)="clickLogin()">Ingresar</button>
                  <br />
                  <label id="label-error-mensaje"
                    style="background-color: rgba(255, 255, 255, 0.8); text-align: left; color: rgb(121, 116, 116);">
                    {{errorMessage}}
                  </label>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>